;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { Card, CardBody, CardTitle, CardText, CardFooter, Col } from 'reactstrap';

import addApiBaseUrl from 'shared/utils/addApiBaseUrl';
import { Dictionaries } from '../i18n/i18n-config';
import Cta from './CtaBtn';
import RegistrationForm from './RegistrationForm';
import VideoPlayer from './VideoPlayer';

function ContentSection({
  section,
  id,
  source,
  className = '',
  dictionary,
}: {
  section: any;
  id?: any;
  source: 'landingPage' | 'event' | 'jobPage' | 'blogPost';
  className?: string;
  dictionary: Partial<Dictionaries>;
}) {
  const { type, content } = section;
  const registrationId = id || `${source}-registration`;

  return (
    <Col
      className={`content-section ${className}`}
      lg={{ size: section.size || 12, order: 0 }}
      xs={{ order: type === 'image' || type === 'video' ? 0 : 1 }}
    >
      {(() => {
        switch (type) {
          case 'image':
            return (
              <img
                className="img-fluid rounded img img-responsive lpImage mx-auto"
                src={`${addApiBaseUrl(content.medium || content.wide.medium)}`}
                srcSet={`${addApiBaseUrl(content.medium || content.square.medium)} 1x, ${addApiBaseUrl(
                  content.large || content.square.large
                )} 2x`}
                alt={content.description}
              />
            );
          case 'paragraph':
            return (
              <div className="h-100 d-flex align-items-center paragraph">
                <div className="py-4 px-lg-4 w-100 h-lg-50" dangerouslySetInnerHTML={{ __html: content }} />
              </div>
            );
          case 'video':
            return <VideoPlayer content={content} />;
          case 'form':
            return <RegistrationForm dictionary={dictionary} id={registrationId} source={source} content={content} />;
          case 'cta':
            return (
              <div className="ctaCards">
                {content.map((cta, index) => {
                  // originally design was made with 3 cta bloks that included images, text and a cta-button
                  // users started using this section just for 1 button,
                  // making the card redundant in this use-case
                  if (!!(!cta.image || !cta.image.wide) && !cta.title && cta.link && cta.link.url && cta.link.cta) {
                    return (
                      <a href={cta.link.url} className="align-self-end" key={`cta-${index}`}>
                        <Cta className="cta red" type="button">
                          {cta.link.cta}
                        </Cta>
                      </a>
                    );
                  }
                  return (
                    <Card className="border-0 mt-3 mb-3" key={`cta-${index}`}>
                      {cta.image && cta.image.wide && (
                        <img
                          className="card-img-top"
                          src={`${addApiBaseUrl(cta.image.wide.small)}`}
                          srcSet={`${addApiBaseUrl(cta.image.wide.small)} 1x, ${addApiBaseUrl(cta.image.wide.medium)} 2x`}
                          alt={addApiBaseUrl(cta.image.description)}
                        />
                      )}
                      <CardBody>
                        <CardTitle tag="h3">{cta.title}</CardTitle>
                        <CardText tag="div">
                          <div dangerouslySetInnerHTML={{ __html: cta.text }} />
                        </CardText>
                      </CardBody>
                      <CardFooter className="bg-white border-0">
                        <a href={cta.link.url} className="align-self-end">
                          <Cta className="cta red" type="button">
                            {cta.link.cta}
                          </Cta>
                        </a>
                      </CardFooter>
                    </Card>
                  );
                })}
              </div>
            );
          default:
        }
      })()}
    </Col>
  );
}

export default ContentSection;
